import { useContext, useEffect, useState } from "react";
import { Flex, Spacer, Button, Box, Text } from "@chakra-ui/react";
import PSLogo from "./../../assets/ps-logo-NEW.svg";
import { AccountContext } from "../../context/AccountContext";
import { Link, useNavigate } from "react-router-dom";
import ProfileMenu from "../Profile/ProfileMenu";
import { Link as RouterLink } from "react-router-dom";

const Header = () => {
  const { logout, user } = useContext(AccountContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const extractNameFromEmail = (email) => {
    const emailSplit = email.split("@");
    const nameArr = emailSplit[0].split(".");
    const nameArrCapitalize = nameArr.map((element) => {
      return capitalizeFirstLetter(element);
    });
    const name = nameArrCapitalize.join(" ");
    setName(name);
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    extractNameFromEmail(user.email);
    setEmail(user.email);
  }, []);

  return (
    <Flex minWidth="max-content" alignItems="center" m="20px" height="50px">
      <Link as={RouterLink} to={"/home"}>
        <img
          src={PSLogo}
          alt="ps logo"
          style={{ height: "100%", minHeight: "50px" }}
        />
      </Link>

      <Spacer />
      <Flex>
        <ProfileMenu name={name} email={email} handleLogout={handleLogout} />
        <Box ml="2">
          <Text fontWeight="bold">{name}</Text>
          <Button size="sm" variant="link" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Header;
